module.exports = __webpack_public_path__ + "img/smile.8889c260.png";